import { documentTypesApi } from "api/documentTypesApi";
import { QUERIES_KEYS } from "queries";
import { useQuery, useQueryClient, keepPreviousData } from "@tanstack/react-query";

export const useDocumentTypes = (
  skip: number,
  limit: number,
  searchPhrase: string = "",
  filter: string = "",
  orderBy: string = "",
) => {
  const queryClient = useQueryClient();
  const { isLoading, isFetching, data } = useQuery({
    queryKey: QUERIES_KEYS.DOCUMENT_TYPES(skip, limit, searchPhrase, filter, orderBy),
    queryFn: () => documentTypesApi.fetch(skip, limit, searchPhrase, filter, orderBy),
    placeholderData: keepPreviousData,
  });

  const invalidate = () => {
    queryClient.invalidateQueries({
      queryKey: QUERIES_KEYS.DOCUMENT_TYPES(skip, limit, searchPhrase, filter, orderBy),
    });
  };

  return { invalidate, isLoading, isFetching, documentTypes: data?.data.data ?? [], total: data?.data.total ?? 0 };
};

export const useDocumentTypesOptions = () => {
  const { isLoading, documentTypes } = useDocumentTypes(0, 1_000_000);

  const options = documentTypes.map((x) => ({
    value: x.id.toString(),
    label: x.name,
  }));

  return { loading: isLoading, options };
};
